module.exports = "/_next/static/images/nflIconActive@3x-a12c7160a46839c42781d56034317f48.png";